import { CheckCircle } from '@mui/icons-material';
import TestSuiteMetrics from '../components/elements/common/TestSuiteMetrics';
import Label from '../ui/primitives/Label';
import { getDateAndTime, getRoleLabel } from '../lib/utils';
import { renderCountryFlagsGrid } from './formatCountryOptions';
import ExpandableList from '../ui/primitives/ExpandableList';
import { Typography } from '@mui/material';
export const usersTableHead = [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    sortable: true,
  },
  {
    key: 'role',
    label: 'Role',
    sortable: false,
    formatContent: (row) => {
      return <span>{row?.role_details?.name || getRoleLabel(row?.role)}</span>;
    },
  },
  {
    key: 'status',
    label: 'Status',
    sortable: false,
    formatContent: (row) => (
      <span
        title={row?.status}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label name={row?.status} />
      </span>
    ),
  },
  {
    key: 'assigned_projects',
    label: 'Assigned Projects',
    sortable: false,
  formatContent: (row) => {
  if (row?.assigned_projects === null) {
    return (
      <Typography variant="body2" color="text.secondary">
        All Projects
      </Typography>
    );
  }
  if (!row?.assigned_projects?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        None
      </Typography>
    );
  }
  return (
    <ExpandableList
      items={row?.assigned_projects || []}
      maxVisible={2}
      renderItem={(project) => (
        <Typography variant="body2">
          {project}
        </Typography>
      )}
    />
  );
},
  },
];

export const projectTeamHeader = [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    key: 'email',
    label: 'Email',
    sortable: true,
  },
  {
    key: 'status',
    label: 'Status',
    sortable: false,
    formatContent: (row) => (
      <span
        title={row?.status}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label name={row?.status} />
      </span>
    ),
  },
  {
    key: 'role',
    label: 'Role',
    sortable: false,
    formatContent: (row) => {
      return <span>{row?.role_details?.name || getRoleLabel(row?.role)}</span>;
    },
  },
];

export const testSuiteHeader = [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
    formatContent: (row) => (
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          fontWeight: row.already_added ? '600' : '500',
        }}>
        {row.name}
        {row.recommended && (
          <span
            style={{
              marginLeft: '8px',
              backgroundColor: '#e0f7fa',
              color: '#1b3f87',
              padding: '2px 6px',
              border: '1px solid #1b3f87',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: '500',
            }}>
            Recommended
          </span>
        )}
      </span>
    ),
  },
  {
    key: 'description',
    label: 'Description',
    sortable: false,
    formatContent: (row) => (
      <span title={row?.description} className="ellipsis">
        {row?.description?.length > 35
          ? `${row?.description?.substring(0, 35)} ...`
          : row?.description}
      </span>
    ),
  },
  {
    key: 'test_case_count',
    label: 'Approved TCs',
    formatContent: (row) => {
      return row.test_case_count || 0;
    },
  },
  {
    key: 'already_added',
    label: '',
    formatContent: (row) =>
      row?.already_added ? (
        <span
          title={
            row.new_test_cases ? 'New test cases added' : 'Previously added'
          }
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          <CheckCircle
            style={{
              color: row?.new_test_cases ? 'var(--primary-color)' : 'grey',
            }}
          />
        </span>
      ) : null,
  },
];

export const testSuiteTableHeader = [
  {
    key: 'name',
    label: 'Name',
    sortable: true,
  },
  {
    key: 'description',
    label: 'Description',
    sortable: false,
    formatContent: (row) => (
      <span title={row?.description} className="ellipsis">
        {row?.description?.length > 35
          ? `${row?.description?.substring(0, 35)} ...`
          : row?.description || '-'}
      </span>
    ),
  },
  {
    key: 'status',
    label: 'Status',
    sortable: true,
    formatContent: (row) => (
      <span
        title={row?.status}
        style={{
          display: 'flex',
          alignItems: 'center',
        }}>
        <Label name={row?.status} />
      </span>
    ),
  },
  {
    key: 'test_case_count',
    label: 'No. of Test Cases',
    formatContent: (row) => {
      return (
        <TestSuiteMetrics
          passPercentage={row.pass_percentage}
          executionPercentage={row.execution_percentage}
          totalTestCases={row.test_case_count}
        />
      );
    },
  },
  {
    key: 'latest_execution_date',
    label: 'Last Executed',
    sortable: true,
    formatContent: (row) => {
      return getDateAndTime(row.latest_execution_date) || 'N/A';
    },
  },
{
  key: 'geographies',
  label: 'Country',
  sortable: false,
  formatContent: (row) => renderCountryFlagsGrid(row.geographies),
},
  // {
  //   key: 'pass_percentage',
  //   label: 'Pass (%)',
  //   formatContent: (row) => {
  //     const percentage = row.pass_percentage;
  //     return (
  //       <LinearProgress
  //         title={`${percentage}%`}
  //         className="progress"
  //         variant="determinate"
  //         value={percentage}
  //         color="success"
  //         sx={{ cursor: 'pointer' }}
  //       />
  //     );
  //   },
  // },
];
